<template>
  <div>
    <div>
      <ElXlsx @upData="upData" />
    </div>
    <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
      <el-table-column prop="month" label="月份">
      </el-table-column>
      <el-table-column prop="province" label="省份">
      </el-table-column>
      <el-table-column prop="htMb" label="合同目标">
      </el-table-column>
      <el-table-column prop="htSj" label="合同实际">
      </el-table-column>
      <el-table-column prop="htWcl" label="合同完成比" width="100">
      </el-table-column>
      <el-table-column prop="htLj" label="合同当年累计" width="110">
      </el-table-column>
      <el-table-column prop="htTq" label="合同上年同期" width="110">
      </el-table-column>
      <el-table-column prop="hkMb" label="回款目标">
      </el-table-column>
      <el-table-column prop="hkSj" label="回款实际">
      </el-table-column>
      <el-table-column prop="hkWcl" label="回款完成比" width="100">
      </el-table-column>
      <el-table-column prop="hkLj" label="回款当年累计" width="110">
      </el-table-column>
      <el-table-column prop="hkTq" label="回款上年同期" width="110">
      </el-table-column>
      <el-table-column prop="fyMb" label="费用目标">
      </el-table-column>
      <el-table-column prop="fySj" label="费用实际">
      </el-table-column>
      <el-table-column prop="fyWcl" label="费用完成比" width="100">
      </el-table-column>
      <el-table-column prop="fyLj" label="费用当年累计" width="110">
      </el-table-column>
      <el-table-column prop="fyTq" label="费用上年同期" width="110">
      </el-table-column>
      <el-table-column prop="zbMb" label="中标目标">
      </el-table-column>
      <el-table-column prop="zbSj" label="中标实际">
      </el-table-column>
      <el-table-column prop="zbWcl" label="中标完成比" width="100">
      </el-table-column>
      <el-table-column prop="zbLj" label="中标当年累计" width="110">
      </el-table-column>
      <el-table-column prop="zbTq" label="中标上年同期" width="110">
      </el-table-column>
      <el-table-column prop="srMb" label="收入目标">
      </el-table-column>
      <el-table-column prop="srSj" label="收入实际">
      </el-table-column>
      <el-table-column prop="srWcl" label="收入完成比" width="100">
      </el-table-column>
      <el-table-column prop="srLj" label="收入当年累计" width="110">
      </el-table-column>
      <el-table-column prop="srTq" label="收入上年同期" width="110">
      </el-table-column>
      <el-table-column prop="ysLj" label="应收账款累计" width="110">
      </el-table-column>
      <el-table-column prop="jzRq" label="截止日期" width="110">
      </el-table-column>
      <el-table-column prop="dqBs" label="大区标识">
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="rows"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog title="导入确认" :visible.sync="dialogConfirm" width="90%" top="8vh" @close="dialogConfirm = false"
      :modal-append-to-body="false" :append-to-body="true">
      <SellConfirm :datas="dataArr"></SellConfirm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirm = false">取 消</el-button>
        <el-button type="primary" @click="importSub" :disabled="btnDisabled">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import ElXlsx from '../../components/ElXlsx.vue'
  import SellConfirm from '../../components/SellConfirm.vue'
  export default {
    components: {
      ElXlsx,
      SellConfirm
    },
    inject: ['reload'],
    data() {
      return {
        loading: true,
        btnDisabled: false,
        dataArr: [],
        dialogConfirm: false,
        spanArr: [],
        tableData: [],
        items: ['month', 'province', 'htMb', 'htSj', 'htWcl', 'htLj', 'htTq', 'hkMb', 'hkSj', 'hkWcl', 'hkLj', 'hkTq', 'fyMb', 'fySj',
          'fyWcl', 'fyLj', 'fyTq', 'zbMb', 'zbSj', 'zbWcl', 'zbLj', 'zbTq', 'srMb', 'srSj', 'srWcl', 'srLj', 'srTq', 'ysLj', 'jzRq', 'dqBs'
        ],
        page: 1,
        rows: 12,
        total: null
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getList() {
        this.loading = true
        this.$axios.post('/sellDataView/findList', {
          current: this.page,
          size: this.rows
        }).then(res => {
          this.loading = false
          this.tableData = res.data.data.records
          this.total = res.data.data.total || res.data.data.records.length
        })
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      getSpanArr(data) {
        // data就是我们从后台拿到的数据
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i].xmdddocno === data[i - 1].xmdddocno) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
          // console.log(this.spanArr);
        }
      },
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 ||
          columnIndex === 5) {
          const _row = this.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          // console.log(`rowspan:${_row} colspan:${_col}`);
          return {
            // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          };
        }
      },
      upData(e) {
        try {
          let dataArr = this.$replaceString(e, this.items, 'noPer')
          this.dataArr = dataArr
          this.dialogConfirm = true
        } catch {
          this.$message({
            message: '文件格式错误！',
            type: 'warning'
          })
        }
      },
      importSub() {
        this.btnDisabled = true
        this.$axios.post('/sellDataView/save', this.dataArr).then(res => {
          console.log(11)
          this.$message({
            type: res.data.code === 400 ? 'error' : 'success',
            message: res.data.code === 400 ? res.data.msg : '添加成功。'
          })
          this.dialogConfirm = false
          this.btnDisabled = false
          this.getList()
        })
      },
    }
  }
</script>

<style scoped>
  .el-table {
    margin-top: 20px;
  }
</style>
